import React, { Component, Fragment } from 'react';
import { makeSkyPredictMap } from './utils';
import { removeLayer } from '@ro-utils/common/helpers';

import { LAYER_SKYPREDICT } from '@ro-utils/constant';

class SkyPredict extends Component {
  componentDidMount() {
    const { data, settings } = this.props;
    this.setSpData(data, settings);
  }
  setSpData(data, settings) {
    const { map } = this.props;
    makeSkyPredictMap(data, map, settings);
  }
  parseAlpha(alpha) {
    return parseInt(alpha, 10) / 100;
  }
  componentWillReceiveProps(nextProps) {
    const { data, settings } = this.props;

    const { data: newData, settings: newSettings } = nextProps;

    if (!newData) {
      removeLayer(LAYER_SKYPREDICT, this.props.map);
    }
    if (
      (newData && JSON.stringify(data) !== JSON.stringify(newData)) ||
      newSettings.opacityFill !== settings.opacityFill ||
      newSettings.opacityStroke !== settings.opacityStroke
    ) {
      removeLayer(LAYER_SKYPREDICT, this.props.map);
      this.setSpData(newData, newSettings);
    }
  }
  render() {
    return <Fragment />;
  }
}

export default SkyPredict;
